import $ from 'jquery';
import Collapse from 'bootstrap/js/dist/collapse';
import { Modal, Popover } from 'bootstrap';

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.navbar-toggler[data-bs-target]');
  if (!trigger) return;

  const target = document.querySelector(trigger.getAttribute('data-bs-target'));
  if (!target) return;

  event.preventDefault();
  event.stopPropagation();
  Collapse.getOrCreateInstance(target, { toggle: false }).toggle();
}, true);

function resolveElement(elementOrSelector) {
  if (typeof elementOrSelector === 'string') {
    return $(elementOrSelector).get(0);
  }

  return elementOrSelector;
}

export function showModal(elementOrSelector, options = {}) {
  const element = resolveElement(elementOrSelector);
  if (!element) return null;

  const instance = Modal.getOrCreateInstance(element, options);
  instance.show();
  return instance;
}

export function hideModal(elementOrSelector) {
  const element = resolveElement(elementOrSelector);
  if (!element) return null;

  const instance = Modal.getOrCreateInstance(element);
  instance.hide();
  return instance;
}

export function toggleModal(elementOrSelector) {
  const element = resolveElement(elementOrSelector);
  if (!element) return null;

  const instance = Modal.getOrCreateInstance(element);
  instance.toggle();
  return instance;
}

export function initializePopovers(selector, options = {}, root = document) {
  return $(root).find(selector).map((index, element) => Popover.getOrCreateInstance(element, options)).get();
}

export { Collapse, Modal, Popover };